export default __webpack_public_path__ + "static/media/LowpassFilterImg.338214cf.jpg";